import { FaqState } from './faq.types';

export const preloadedState: FaqState = {
  content: '',
  loading: false,
  updating: false,
};
